// 获取租户id
const pagination = {
  pageSizeOptions: ['10'],
  pageNum: 1,
  pageSize: 10,
  defaultCurrent: 1,
  showQuickJumper: true,
  showSizeChanger: false,
  current: 1,
  total: 0,
  showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
};

export default {
  pagination
}


// WEBPACK FOOTER //
// ./src/utils/constants.js